import axios from "axios/index";
import api from "../../config/_api";
import {PLATES_UPDATED} from "../actions/plates";
//import {isSubscriptionValid} from "../modules/auth";

const state = {
    plates: []
};
const actions = {
    getPlates: ({commit, rootGetters}) => {
        /*var option = "";
        if(!isSubscriptionValid()){
            option = "&withMirror=yes";
        }*/
        axios({url: api.url + 'plates?structure_id=' + rootGetters.structure_id, method: 'GET'})
            .then(resp => {
                commit('PLATES_UPDATED', resp.data);
            })
            .catch(err => {
               // console.log(err);
            });
    }
};
const mutations = {
    [PLATES_UPDATED]: (state, plates) => {
        state.plates = plates;
    },
};
const getters = {
    plates : state => state.plates,
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
//# sourceMappingURL=sensors.js.map